<template>
  <a
    :href="project.url"
    class="project-item"
    :class="elClasses"
    >
    <figure>
      <img :data-src="imageUrl" ref="image">
    </figure>

    <div class="absolute inset-0 flex items-center justify-center w-full h-full p-4 text-white bg-black opacity-0 md:p-8 project-overlay bg-opacity-75 transition-opacity duration-300">
      <div class="text-center">
        <div class="text-xl font-bold lg:text-2xl xl:text-3xl">{{ project.title }}</div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'CoverPhoto',

  props: {
    project: {
      type: Object,
      default: () => {}
    },

    cover: {
      type: Object,
      default: () => {}
    },
  },

  computed: {
    imageUrl() {
      return `/assets/${this.cover.url}`
    },

    elClasses() {
      const classes = []

      if (this.cover.is_double_width) {
        classes.push('width-2')
      }

      if (this.cover.is_double_height) {
        classes.push('height-2')
      }

      return classes.join(' ')
    }
  },

  mounted() {
    const delay = Math.random() / 2
    this.$refs.image.style.setProperty('--enter-delay', `${delay}s`)
  }
}
</script>
